import { MenuItem } from "@mui/material"

export function SkillMenuItem({ item }) {
    return (
        <MenuItem key={item.CoreSkillingID} value={String(item.CoreSkillingID)}>
            {item.SkillingCode} — {item.Skilling}
        </MenuItem>
    )
}
